import { Modal } from '@bp/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SubmissionEditRequestForm } from '../forms/SubmissionEditRequestForm';

type SubmissionEditRequestModalProps = {
  submissionUuid: string;
  isOpen: boolean;
  onClose: () => void;
};

export const SubmissionEditRequestModal = ({ submissionUuid, isOpen, onClose }: SubmissionEditRequestModalProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState<boolean>(false);

  return (
    <Modal
      width='s'
      title={t('submissions.requestToFeedback')}
      isOpen={isOpen}
      loading={loading}
      onRequestClose={() => onClose()}
    >
      <SubmissionEditRequestForm
        submissionUuid={submissionUuid}
        onLoading={(loading) => setLoading(loading)}
        onClose={() => onClose()}
      />
    </Modal>
  );
};
